export const PLAYER = {
  name: 'Player Name',
  stats: {
    // speed: 0.05,
    // power: 2
  }
};
